import { createSelector } from 'reselect';
import { UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
export const getThemeSettings = state => state.resources.themeSettings.themeSettings;
export const getThemeSettingsFetchStatus = (state, moduleProps = {}) => {
  const {
    folderPath
  } = moduleProps;
  if (!folderPath) return UNINITIALIZED;
  const requestObj = state.resources.themeSettings.themeSettingRequestStatus;
  return requestObj[folderPath] || UNINITIALIZED;
};
export const getThemeSettingsValues = createSelector([getThemeSettings], themeSettings => {
  if (!themeSettings.themeSettings || !themeSettings.themeSettings.values) {
    return {};
  }
  return themeSettings.themeSettings.values;
});
export const getThemeFields = createSelector([getThemeSettings], themeSettings => {
  if (!themeSettings.theme || !themeSettings.theme.fields) return [];
  return themeSettings.theme.fields;
});
export const getThemePresetStyles = createSelector([getThemeSettings], themeSettings => {
  var _themeSettings$buffer;
  return (_themeSettings$buffer = themeSettings.bufferedThemePreset) === null || _themeSettings$buffer === void 0 ? void 0 : _themeSettings$buffer.styles;
});